document.addEventListener("click", async (event) => {

  const button = event.target.closest(
    ".product-card__cart"
  );

  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const variantId =
    button.dataset.variantId;

  if (!variantId) return;

  button.disabled = true;

  try {

    const response = await fetch(
      "/cart/add.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        "Failed to add item"
      );
    }

    button.classList.add(
      "is-added"
    );

    const cartResponse =
      await fetch("/cart.js");

    const cart =
      await cartResponse.json();

    const cartCount =
      document.querySelector(
        ".header-cart-count"
      );

    if (cartCount) {

      cartCount.textContent =
        cart.item_count;

    }

  } catch (error) {

    console.error(error);

  } finally {

    button.disabled = false;

  }

});